import { Injectable } from '@angular/core';

/*
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider {
  collection(arg0: string) {
    throw new Error("Method not implemented.");
  }
  public online: boolean = true;
  public userId: string;
  public password: string;
  public userName: string;
  public phone: string;
  public email: any;
  public workYearIn: any;
  public role: string;
  public farm_id: string;
  public farmName: string;
  public currentTabName: string;
  public Cow_Count: any;
  
  constructor() {
    console.log('Hello DataProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts